export interface SelfScheduledStateInfo {
  wakeAt: string;
  reason: string;
}

/**
 * Extract self-scheduled wake-up state from a chat's application state.
 *
 * Returns null when no schedule is active. Available for any agent type: ScheduleForFuture is a
 * regular assistant tool, not limited to co-scientist chats.
 */
export function getSelfScheduledState(applicationState: object | null): SelfScheduledStateInfo | null {
  if (applicationState == null) {
    return null;
  }

  const state = applicationState as {self_schedule?: {wake_at?: unknown; reason?: unknown} | null};
  const selfSchedule = state.self_schedule;
  if (selfSchedule == null) {
    return null;
  }
  if (typeof selfSchedule.wake_at !== 'string' || typeof selfSchedule.reason !== 'string') {
    return null;
  }

  return {
    wakeAt: selfSchedule.wake_at,
    reason: selfSchedule.reason,
  };
}
